var scope_0 = require('/Users/peterkrajcovic/Documents/Web/GatsbyProject/globaltel_V5_actual/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2b665029cc1fa52c1806643bc07c80b9.js').default;
var scope_1 = require('/Users/peterkrajcovic/Documents/Web/GatsbyProject/globaltel_V5_actual/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    